import { AboutCityComponent } from "./event/about-city/about-city.component";
import { RouterModule, Routes } from "@angular/router";
import { LoginComponent } from "./user/login/login.component";
import { AuthguardGuard } from "./core/guards/authguard.guard";
import { WelcomeComponent } from "./event/welcome/welcome.component";
import { InfoComponent } from "./event/info/info";
import { MenuTypeComponent } from "./event/menu-type/menu-type";
import { MenuItemsComponent } from "./event/menu-items/menu-items";
import { AboutUsComponent } from "./event/about-us/about-us.component";
import { ThemeComponent } from "./event/theme/theme.component";
import { Theme2Component } from "./event/theme2/theme2.component";
import { Constants } from "./core/config/Constants";
import { ForgotPasswordComponent } from "./user/forgot-password/forgot-password.component";
import { SpeakersFormComponent } from "./event/speakers-form/speakers-form.component";
import { SpeakerProfileComponent } from "./event/speaker-profile/speaker-profile.component";
import { RegistrationComponent } from "./user/registration/registration.component";
import { ProfileComponent } from "./user/profile/profile.component";
import { SessionsFormComponent } from "./event/sessions-form/sessions-form.component";
import { SessionsAddComponent } from "./event/sessions-add/sessions-add.component";
import { ContentFormComponent } from "./event/content-form/content-form.component";
import { DropDownComponent } from "./layout/drop-down/drop-down.component";

import { ImageSliderComponent } from "./event/image-slider/image-slider.component";
import { ContentAddComponent } from "./event/content-add/content-add.component";
import { PollFormComponent } from "./event/poll-form/poll-form.component";
import { PollAddComponent } from "./event/poll-add/poll-add.component";
import { SponsorsFormComponent } from "./event/sponsors-form/sponsors-form.component";
import { ContactUsFormComponent } from "./event/contact-us-form/contact-us-form.component";
import { ContactUsAddComponent } from "./event/contact-us-add/contact-us-add.component";
import { ChatroomComponent } from "./event/chatroom/chatroom.component";
import { FeedbackComponent } from "./event/feedback/feedback.component";
import { QuestionAndAnswerComponent } from "./event/question-and-answer/question-and-answer.component";
import { PublishComponent } from "./event/publish/publish.component";
import { ResetComponent } from "./event/reset/reset.component";

import { PopupScreenComponent } from "./event/popup-screen/popup-screen.component";
import { PollListComponent } from "./event/poll-list/poll-list.component";

import { AttendeesComponent } from "./event/attendees/attendees.component";
import { Attendees2Component } from "./event/attendees2/attendees2.component";
import { SplashScreenComponent } from "./event/splash-screen/splash-screen.component";
import { VenueDetailComponent } from "./event/venue-detail/venue-detail.component";
import { ExhibitorListComponent } from "./event/exhibitor-list/exhibitor-list.component";
import { TestComponent } from "./event/test/test.component";
import { SpeakerListComponent } from "./event/speaker-list/speaker-list.component";
import { SpeakerAddComponent } from "./event/speaker-add/speaker-add.component";
import { OrganizerListComponent } from "./event/organizer-list/organizer-list.component";
import { OrganizerAddComponent } from "./event/organizer-add/organizer-add.component";
import { NotificationComponent } from "./event/notification/notification.component";
import { SponsorsAddNewComponent } from "./event/sponsors-add-new/sponsors-add-new.component";
import { ExhibitorAddNewComponent } from "./event/exhibitor-add-new/exhibitor-add-new.component";

import { ExportCsvComponent } from "./extras/export-csv/export-csv.component";
import { Registration2Component } from "./event/registration2/registration2.component";
import { PollQuestionComponent } from "./event/poll-question/poll-question.component";
import { DisclaimerComponent } from "./event/disclaimer/disclaimer.component";
import { SessionsTopicComponent } from "./event/session-topic/sessions-topic.component";
import { ActivitiesComponent } from "./event/activities/activities.component";
import { ContactUsComponent } from "./user/contact-us/contact-us.component";
import { LiveStreamingComponent } from "./event/live-streaming/live-streaming.component";

export const appRoutes: Routes = [
  {
    path: "user",
    children: [
      { path: "login", component: LoginComponent },
      { path: "forgot-password", component: ForgotPasswordComponent },
      {
        path: "contactUs",
        component: ContactUsComponent
      },
      { path: "sign-up", component: RegistrationComponent },
      { path: "profile", component: ProfileComponent }
    ]
  },
  {
    path: "welcome",
    canActivate: [AuthguardGuard],
    component: WelcomeComponent
  },
  {
    path: "welcome",
    canActivate: [AuthguardGuard],
    component: WelcomeComponent
  },
  {
    path: "event",
    children: [
      { path: "info", canActivate: [AuthguardGuard], component: InfoComponent },
      {
        path: "menu-type/:eventId",
        canActivate: [AuthguardGuard],
        component: MenuTypeComponent
      },
      {
        path: "about-us/:eventId",
        canActivate: [AuthguardGuard],
        component: AboutUsComponent
      },
      {
        path: "disclaimer/:eventId",
        canActivate: [AuthguardGuard],
        component: DisclaimerComponent
      },
      {
        path: "AboutCity/:eventId",
        canActivate: [AuthguardGuard],
        component: AboutCityComponent
      },
      {
        path: "Streaming/:eventId",
        canActivate: [AuthguardGuard],
        component: LiveStreamingComponent,
      },
      {
        path: "activities/:eventId",
        canActivate: [AuthguardGuard],
        component: ActivitiesComponent
      },
      {
        path: "Registration/:eventId",
        canActivate: [AuthguardGuard],
        component: Registration2Component
      },
      // { path: 'info',canActivate:[AuthguardGuard], component: InfoComponent },
      // { path: 'menu-type/:eventId', canActivate:[AuthguardGuard],component: MenuTypeComponent },
      // { path: 'about-us/:eventId',canActivate:[AuthguardGuard], component: AboutUsComponent },

      {
        path: "menu-items/:eventId",
        canActivate: [AuthguardGuard],
        component: MenuItemsComponent
      },
      {
        path: "theme/:eventId",
        canActivate: [AuthguardGuard],
        component: Theme2Component
      },
      // {path: 'speakers-form/:eventId', canActivate: [AuthguardGuard], component: SpeakersFormComponent},
      {
        path: "speakers-form/:eventId",
        canActivate: [AuthguardGuard],
        component: SpeakerListComponent
      },
      // {path: 'speaker-profile', canActivate: [AuthguardGuard], component: SpeakerProfileComponent},
      {
        path: "speaker-profile",
        canActivate: [AuthguardGuard],
        component: SpeakerAddComponent
      },
      {
        path: "sessions-form/:eventId",
        canActivate: [AuthguardGuard],
        component: SessionsFormComponent
      },
      {
        path: "sessions-topic/:eventId",
        canActivate: [AuthguardGuard],
        component: SessionsTopicComponent
      },
      {
        path: "sessions-add",
        canActivate: [AuthguardGuard],
        component: SessionsAddComponent
      },
      {
        path: "content-form/:eventId",
        canActivate: [AuthguardGuard],
        component: ContentFormComponent
      },

      {
        path: "sponsors-form/:eventId",
        canActivate: [AuthguardGuard],
        component: SponsorsFormComponent
      },
      {
        path: "exhibitors/:eventId",
        canActivate: [AuthguardGuard],
        component: ExhibitorListComponent
      },
      {
        path: "organizers/:eventId",
        canActivate: [AuthguardGuard],
        component: OrganizerListComponent
      },
      {
        path: "sponsors-add",
        canActivate: [AuthguardGuard],
        component: SponsorsAddNewComponent
      },
      {
        path: "exhibitor-add",
        canActivate: [AuthguardGuard],
        component: ExhibitorAddNewComponent
      },
      {
        path: "organizer-add",
        canActivate: [AuthguardGuard],
        component: OrganizerAddComponent
      },

      { path: "test", canActivate: [AuthguardGuard], component: TestComponent },

      // { path: 'registration/:eventId',canActivate:[AuthguardGuard], component: ExhibitorListComponent },
      {
        path: "notification/:eventId",
        canActivate: [AuthguardGuard],
        component: NotificationComponent
      },

      {
        path: "image-slider/:eventId",
        canActivate: [AuthguardGuard],
        component: ImageSliderComponent
      },
      {
        path: "content-add",
        canActivate: [AuthguardGuard],
        component: ContentAddComponent
      },
      {
        path: "poll-form/:eventId",
        canActivate: [AuthguardGuard],
        component: PollFormComponent
      },
      {
        path: "poll-add",
        canActivate: [AuthguardGuard],
        component: PollAddComponent
      },
      {
        path: "poll-question",
        canActivate: [AuthguardGuard],
        component: PollQuestionComponent
      },
      {
        path: "contact-us-form/:eventId",
        canActivate: [AuthguardGuard],
        component: ContactUsFormComponent
      },
      {
        path: "contact-us-add",
        canActivate: [AuthguardGuard],
        component: ContactUsAddComponent
      },
      {
        path: "chatroom/:eventId",
        canActivate: [AuthguardGuard],
        component: ChatroomComponent
      },
      {
        path: "feedback/:eventId",
        canActivate: [AuthguardGuard],
        component: FeedbackComponent
      },
      {
        path: "question-and-answer/:eventId",
        canActivate: [AuthguardGuard],
        component: QuestionAndAnswerComponent
      },
      {
        path: "publish/:eventId",
        canActivate: [AuthguardGuard],
        component: PublishComponent
      },
      {
        path: "reset/:eventId",
        canActivate: [AuthguardGuard],
        component: ResetComponent
      },

      {
        path: "popup-screen/:eventId",
        canActivate: [AuthguardGuard],
        component: PopupScreenComponent
      },
      {
        path: "poll-list/:eventId",
        canActivate: [AuthguardGuard],
        component: PollListComponent
      },
      {
        path: "attendees/:eventId",
        canActivate: [AuthguardGuard],
        component: AttendeesComponent
      },
      {
        path: "attendees2/:eventId",
        canActivate: [AuthguardGuard],
        component: Attendees2Component
      },
      {
        path: "splash-screen/:eventId",
        canActivate: [AuthguardGuard],
        component: SplashScreenComponent
      },
      {
        path: "venue-detail/:eventId",
        canActivate: [AuthguardGuard],
        component: VenueDetailComponent
      }
    ]
  },
  {
    path: "export-csv",
    canActivate: [AuthguardGuard],
    component: ExportCsvComponent
  },
  { path: "", redirectTo: "user/login", pathMatch: "full" },
  { path: "contactUs", redirectTo: "user/contactUs", pathMatch: "full" },
  { path: "**", redirectTo: "user/login", pathMatch: "full" }
];



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/app.routes.ts